import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { RegistroNegocioPendienteModel } from './RegistroNegocioPendiente.model'
import { consultaIntefazNegocio } from './RegistroNegocioPendiente.model'
import { of } from 'rxjs/observable/of';


@Component({
	selector: 'consultarInterfaz',
	templateUrl: './ConsultarInterfaz.component.html',
	styleUrls: ['../../../../styles.css']

})
export class ConsultarInterfazComponent {

	public prefijo: string;
	public numero: string;
	public user:String;
	myControl = new FormControl();
	public form: FormGroup;
	public formErrors: any;
	public cargando: boolean = false;

	public displayedColumns = ['Negocio', 'Pendientes'];
	public dataDataBase: RegistroDatabaseInterfaz;
	public dataSource: ExampleDataSource;
	public render: boolean = false;

	public ocultar: boolean= false;
	public mensaje: string="";


	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar) {

		this.prefijo = "";
		this.numero = "";
		this.user = "";

		this.formErrors = {

			prefijo: {},
			numero: {}

		};
		this.snackBar.dismiss();
	}

	ngOnInit() {

		this.form = this.formBuilder.group({
			prefijo: ['', Validators.required],
			numero: ['', Validators.required]
		});

		this.form.valueChanges.subscribe(() => {
			for (const field in this.formErrors) {
				if (!this.formErrors.hasOwnProperty(field)) {
					continue;
				}

				// Clear previous errors
				this.formErrors[field] = {};

				// Get the control
				const control = this.form.get(field);

				if (control && control.dirty && !control.valid) {
					this.formErrors[field] = control.errors;
				}
			}
		});
	}

	public consultarInterfaz() {

		this.render = false;
		this.cargando = true;

		this._serviciosGenerales.get('colsutarPrefijo', 
		{ 
			prefijo: this.prefijo, 
			user:this._serviciosGenerales.seguridad.getInfoSesion().usuario
			}).subscribe(
			result => {
				this.cargando = false;
				if (result.length == 0) {
					this.openSnackBarEspecial("No se encontraron registros", "X");
					return;
				}
			
				if(result[0].Existen == 0){
					this.openSnackBarEspecial("Prefijo y nro ingresado no existe o no esta relacionado a este usuario", "X");
					return;
				}

				this.consultar();

			}, error => {
				this.cargando = false;
				this.openSnackBarEspecial("Ocurrió un error al momento de consultar la información", "X");
			}
		)

	}

	public consultar(){

		this._serviciosGenerales.get('colsutarInterfaz', 
		{ 
			prefijo: this.prefijo+'-'+this.numero, 
			}).subscribe(
			result => {
				this.cargando = false;
				if (result.length == 0) {
					this.openSnackBarEspecial("No se encontraron registros", "X");
					return;
				}
				
				this.snackBar.dismiss(); 
				this.dataDataBase = new RegistroDatabaseInterfaz();

				for (let x of result) {
					this.dataDataBase.addRegistro(new consultaIntefazNegocio(x.CNOMBREARCHIVO,new Date(x.FECHA).toLocaleString()));
				}

				this.dataSource = new ExampleDataSource(this.dataDataBase);
				this.render = true;

			}, error => {
				this.cargando = false;
				this.openSnackBarEspecial("Ocurrió un error al momento de consultar la información", "X");
			}
		)

	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});

	}
	openSnackBarEspecial(message: string, action: string) {
        let snackBarRef =  this.snackBar.open(message, action);
 
        snackBarRef.onAction().subscribe(() => {
           
            this.ocultar = false;
            this.mensaje = "";
        });
        
        let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;        
        
        if (shand.length != 0) {
                for (let i=0;i<shand.length;i++){
                shand[i].style.backgroundColor = "rgb(255 204 214)";
                }
            }
    }

}

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class RegistroDatabaseInterfaz {

	dataChange: BehaviorSubject<consultaIntefazNegocio[]> = new BehaviorSubject<consultaIntefazNegocio[]>([]);

	get data(): consultaIntefazNegocio[] {
		return this.dataChange.value;
	}

	addRegistro(log: consultaIntefazNegocio) {
		const copiedData = this.data.slice();
		copiedData.push(log);
		this.dataChange.next(copiedData);
	}

}

export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string {
		return this._filterChange.value;
	}

	set filter(filter: string) {
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: RegistroDatabaseInterfaz) {
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<consultaIntefazNegocio[]> {
		const displayDataChanges = [
			this._exampleDatabase.dataChange,
			this._filterChange
		];

		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: consultaIntefazNegocio) => {
				let searchStr = (item.interfaz).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect() {
	}
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ConsultarInterfaz/ConsultarInterfaz.component.ts